<button [ngClass]="navButton.btnClass"
        type="button"
        (click)="navigate()"
        [attr.data-testid]="'warranty-nav-' + (navButton.btnText | lowercase)">
  {{ navButton.btnText }}
</button>